<template>
  <header class="header-global">

    <!-- 側邊欄遮罩 -->
    <transition name="fade">
      <div v-if="sidebarOpen" class="sidebar-overlay" @click="closeSidebar"></div>
    </transition>

    <!-- 側邊欄 -->
    <transition name="slide-left">
      <div v-if="sidebarOpen" class="sidebar">
        <div class="sidebar-header">
          <router-link to="/" @click.native="closeSidebar">
            <img :src="$baseUrl + 'img/brand/logo.png'" height="40" alt="logo">
          </router-link>
        </div>
        <nav class="sidebar-nav">
          <router-link :to="{name: 'customer_bills'}" class="sidebar-link" @click.native="closeSidebar">
            <i class="fa fa-file-text mr-2"></i>我的帳單
          </router-link>
          <router-link :to="{name: 'favorite'}" class="sidebar-link" @click.native="closeSidebar">
            <i class="fa fa-heart mr-2"></i>我的收藏
          </router-link>
          <router-link :to="{name: 'latest'}" class="sidebar-link" @click.native="closeSidebar">
            <i class="fa fa-list-alt mr-2"></i>最新訂單
          </router-link>
          <router-link :to="{name: 'past'}" class="sidebar-link" @click.native="closeSidebar">
            <i class="fa fa-calendar-check-o mr-2"></i>過往訂單
          </router-link>
          <router-link :to="{name: 'history'}" class="sidebar-link" @click.native="closeSidebar">
            <i class="fa fa-history mr-2"></i>歷史訂單
          </router-link>
          <div class="sidebar-bottom">
            <a v-if="canSwitchOrganization" class="sidebar-link" href="javascript:void(0)" @click="switchOrganization">
              <i class="fa fa-exchange mr-2"></i>
              <span class="sidebar-org-label">切換門市<small class="sidebar-org-name">{{ currentOrganizationName }}</small></span>
            </a>
            <a class="sidebar-link sidebar-link-logout" href="javascript:void(0)" @click="clickLogout">
              <i class="fa fa-sign-out mr-2"></i>登出
            </a>
          </div>
        </nav>
      </div>
    </transition>

    <base-nav class="navbar-main position-fixed bg-white z-20" transparent type="" effect="" expand>

      <!-- 覆寫 brand slot 為空，避免預設 anchor 佔位 -->
      <template v-slot:brand></template>

      <!-- container-after slot：在 collapse 之外，所有螢幕都顯示 -->
      <template v-slot:container-after>
        <div class="nav-inner d-flex align-items-center w-100">

          <!-- 左：hamburger -->
          <button class="hamburger-btn" @click="toggleSidebar">
            <i class="fa fa-bars fa-lg" aria-hidden="true"></i>
          </button>

          <!-- 左：LOGO（只在大螢幕顯示） -->
          <router-link to="/" class="navbar-logo d-none d-lg-flex align-items-center ml-2">
            <img :src="$baseUrl + 'img/brand/logo.png'" class="logo-img" alt="logo">
          </router-link>

          <!-- 右：搜尋欄 -->
          <form class="search-form ml-auto" @submit.prevent="doSearch">
            <div class="input-group">
              <input
                type="text"
                class="form-control search-input"
                placeholder="搜尋 JAN / 品名 / 品牌 / 訂單關鍵字或依結單日快速找貨"
                v-model="searchKeyword"
              />
              <div class="input-group-append">
                <button class="btn btn-search" type="submit">
                  <i class="fa fa-search"></i>
                </button>
              </div>
            </div>
          </form>

          <!-- 右：通知鈴鐺 -->
          <NotificationBell class="ml-2"/>

        </div>
      </template>
      <!-- 不使用 default slot（不需要 Bootstrap collapse 內容） -->
    </base-nav>
  <notice-dialog
    :show.sync="showExpiredDialog"
    title="登入逾時"
    message="一段時間未動作，已自動登出"
    primary-text="重新登入"
    primary-type="main-color"
    @primary="$router.push('/login')"
  />
  </header>
</template>

<script>
import BaseNav from "@/components/BaseNav";
import NoticeDialog from "@/components/dialogs/NoticeDialog.vue";
import NotificationBell from "@/layout/NotificationBell.vue";
import * as push from "@/util/push";

export default {
  components: {
    BaseNav,
    NoticeDialog,
    NotificationBell,
  },
  data() {
    return {
      sidebarOpen: false,
      searchKeyword: '',
      now: Date.now(),
      timer: null,
      showExpiredDialog: false,
      sessionExpiredShown: false,
    }
  },
  computed: {
    canSwitchOrganization() {
      return (this.$store.state.myOrganizations || []).length > 1 && !!this.$store.state.myOrganization;
    },
    currentOrganizationName() {
      const org = this.$store.state.myOrganization || {};
      return org.store_name || org.name || '';
    },
    tokenExpiry() {
      const token = this.$store.state.token;
      if (!token) return null;
      const t = token.replace(/^Bearer\s+/i, '');
      const parts = t.split('.');
      if (parts.length !== 3) return null;
      try {
        const payload = JSON.parse(atob(parts[1].replace(/-/g, '+').replace(/_/g, '/')));
        if (payload.exp) return payload.exp * 1000;
        if (payload.expired_at) return new Date(payload.expired_at).getTime();
        return null;
      } catch (e) {
        return null;
      }
    },
    tokenExpiryText() {
      if (!this.tokenExpiry) return '';
      const diff = this.tokenExpiry - this.now;
      if (diff <= 0) return 'Token 已到期';
      const totalSec = Math.floor(diff / 1000);
      const days = Math.floor(totalSec / 86400);
      const hours = Math.floor((totalSec % 86400) / 3600);
      const mins = Math.floor((totalSec % 3600) / 60);
      const secs = totalSec % 60;
      const pad = n => String(n).padStart(2, '0');
      if (days > 0) return days + '天 ' + pad(hours) + '時 ' + pad(mins) + '分 ' + pad(secs) + '秒 後到期';
      if (hours > 0) return pad(hours) + '時 ' + pad(mins) + '分 ' + pad(secs) + '秒 後到期';
      return pad(mins) + '分 ' + pad(secs) + '秒 後到期';
    },
    tokenExpiryDate() {
      if (!this.tokenExpiry) return '';
      const d = new Date(this.tokenExpiry);
      const pad = n => String(n).padStart(2, '0');
      return d.getFullYear() + '/' + pad(d.getMonth() + 1) + '/' + pad(d.getDate()) + ' ' + pad(d.getHours()) + ':' + pad(d.getMinutes());
    },
    tokenExpiryClass() {
      if (!this.tokenExpiry) return '';
      const diff = this.tokenExpiry - this.now;
      if (diff <= 0) return 'expiry-danger';
      if (diff < 60 * 60 * 1000) return 'expiry-danger';
      if (diff < 24 * 60 * 60 * 1000) return 'expiry-warning';
      return 'expiry-ok';
    },
  },
  created() {
    this.searchKeyword = this.$route.query.q || '';
    this.timer = setInterval(() => {
      this.now = Date.now();
      if (this.tokenExpiry && !this.sessionExpiredShown && this.tokenExpiry <= this.now) {
        this.sessionExpiredShown = true;
        this.$store.dispatch('clear');
        this.showExpiredDialog = true;
      }
    }, 1000);
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  watch: {
    '$route'(to) {
      this.searchKeyword = to.query.q || '';
      this.closeSidebar();
    }
  },
  methods: {
    switchOrganization() {
      this.closeSidebar();
      this.$router.push({name: 'select-organization', query: {switch: '1'}});
    },
    toggleSidebar() {
      this.sidebarOpen = !this.sidebarOpen;
    },
    closeSidebar() {
      this.sidebarOpen = false;
    },
    doSearch() {
      const q = this.searchKeyword.trim();
      if (q) {
        this.$router.push({ name: 'search', query: { q } });
      }
    },
    async clickLogout() {
      this.closeSidebar();
      // 先取消這個瀏覽器的推播登記（要趁還沒登出、token 還有效時呼叫），否則下一個人用這台電腦會收到上一個人的推播
      try {
        await Promise.race([push.disable(), new Promise(resolve => setTimeout(resolve, 3000))]);
      } catch (e) {
        // 取消推播登記失敗不影響登出，直接往下走
      }
      this.$store.dispatch('userSignOut');
    },
  }
};
</script>

<style lang="scss" scoped>

.z-20 {
  z-index: 20;
}

/* 隱藏 BaseNav 內建的 Bootstrap toggle button */
::v-deep .navbar-toggler {
  display: none !important;
}

/* 確保 container 是 flex 且不換行 */
::v-deep .container {
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
}

/* 大小螢幕 navbar 間距一致，內容垂直置中 */
::v-deep .navbar-main {
  padding-top: 12px !important;
  padding-bottom: 12px !important;
  min-height: 70px;
  align-items: center;
}

.nav-inner {
  min-height: 46px;
  align-items: center;
}

/* ===== 側邊欄遮罩 ===== */
.sidebar-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.4);
  z-index: 30;
}

/* ===== 側邊欄 ===== */
.sidebar {
  position: fixed;
  top: 0;
  left: 0;
  width: 260px;
  height: 100vh;
  background: #fff;
  z-index: 40;
  display: flex;
  flex-direction: column;
  box-shadow: 4px 0 16px rgba(0, 0, 0, 0.15);
}

.sidebar-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  border-bottom: 1px solid #eee;
}

.sidebar-close-btn {
  background: none;
  border: none;
  cursor: pointer;
  color: #555;
  padding: 4px 8px;
  &:hover {
    color: #000;
  }
}

.sidebar-nav {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  padding: 12px 0;
}

/* 切換門市與登出固定在選單最下方 */
.sidebar-bottom {
  margin-top: auto;
  display: flex;
  flex-direction: column;
}

.sidebar-org-label {
  display: flex;
  flex-direction: column;
  line-height: 1.2;
}

.sidebar-org-name {
  color: #999;
}

.sidebar-link {
  display: flex;
  align-items: center;
  padding: 14px 24px;
  color: #32325d;
  font-size: 15px;
  font-weight: 500;
  text-decoration: none;
  transition: background 0.15s;

  &:hover,
  &.router-link-active {
    background: #f5f7ff;
    color: var(--main-color, #5e72e4);
  }

  &.sidebar-link-logout {
    color: #888;
    &:hover {
      background: #fff5f5;
      color: #e53e3e;
    }
  }
}

/* ===== Navbar 內容 ===== */
.hamburger-btn {
  background: none;
  border: none;
  cursor: pointer;
  color: #F39800;
  padding: 6px 10px;
  flex-shrink: 0;
  font-size: 1.4rem;
  line-height: 1;
  &:hover {
    color: darken(#F39800, 10%);
  }
}

.navbar-logo {
  text-decoration: none;
}

.logo-img {
  height: 36px;
  object-fit: contain;
}

/* ===== 搜尋欄 ===== */
.search-form {
  width: 100%;
  max-width: 280px;
  min-width: 0;

  @media (min-width: 992px) {
    max-width: 460px;
  }
}

.search-input {
  border-radius: 20px 0 0 20px;
  border: 1px solid #ddd;
  background: #f5f5f5;
  font-size: 14px;
  padding: 6px 14px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  &::placeholder {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  &:focus {
    outline: none;
    box-shadow: none;
    border-color: #aaa;
    background: #fff;
  }
}

.btn-search {
  border-radius: 0 20px 20px 0;
  background-color: var(--main-color, #5e72e4);
  color: #fff;
  border: 1px solid var(--main-color, #5e72e4);
  padding: 6px 14px;
  &:hover {
    opacity: 0.85;
  }
}

/* ===== Token 到期 ===== */
.token-expiry {
  font-size: 12px;
  font-weight: 500;
  white-space: nowrap;
  flex-shrink: 0;
}
.expiry-ok    { color: #40BD8B; }
.expiry-warning { color: #E89100; }
.expiry-danger  { color: #FF3709; }
.token-expiry-date { font-size: 11px; opacity: 0.75; }

/* ===== 動畫 ===== */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.25s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.slide-left-enter-active,
.slide-left-leave-active {
  transition: transform 0.25s ease;
}
.slide-left-enter,
.slide-left-leave-to {
  transform: translateX(-100%);
}

</style>
